import { Rule } from "antd/lib/form";

export const AsyncValid: { [key: string]: Rule } = {
  mobile: {
    type: "string",
    pattern: /^\+1\d{10}/,
    message: "Mobile number is missing digits",
    transform: (x) => x?.replace(/[ \-()]/g, ""),
  },
};

export const Rules: { [key: string]: Rule[] } = {
  email: [{ type: "email", message: "The input is not valid E-mail", required: true }],
};
